// eslint-disable-next-nine @typescript-eslint/no-use-before-define
import React from 'react'
import { Box, Flex, Divider } from '@chakra-ui/core'
import styled from '@emotion/styled'
import NavMenu from './NavMenu'
import { useSelector } from 'react-redux'
import keys from 'constants/keys'
import { RootState } from 'constants/interfaces'
import { DEVICE_TYPES } from 'constants/UI'
import useWindowDimensions from 'hooks/useWindowDimensions'
import Logo from 'components/Header/Logo'
import { Link } from 'react-router-dom'
import { isRtlSelector } from 'redux/selectors/general'
import SidebarUserCard from './SidebarUserCard'

const StyledSidebar = styled(Box)`
  --sidebar-font-size: 13px;
  --sidebar-icon-size: 28px;
  --sidebar-glyph-size: 17px;
  --sidebar-row-padding: 5px 8px;
  --sidebar-heading-margin: 10px 8px 4px;
  width: 300px;
  min-height: 0;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  overflow: visible;
  display: flex;
  flex-direction: column;
  background-color: white;
  *:focus {
    outline: none;
    box-shadow: none;
  }
`

const ScrollableMenu = styled(Box)`
  --scrollbar-track-color: transparent;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-gutter: stable;
  padding-inline-start: 16px;
  padding-inline-end: 10px;
  background-color: white;
`

const Sidebar = () => {
  const { retailConfig } = useSelector((state: RootState) => state.config)
  const { windowWidth } = useWindowDimensions()
  const theme = useSelector((state: RootState) => state.general.theme)
  const logoSrc = theme?.logoUrl || retailConfig?.logo_image_url
  const isRtl = useSelector(isRtlSelector)

  return (
    <StyledSidebar as="aside" p="0" flexDirection="column" justifyContent="space-between" h="100%">
      <ScrollableMenu data-scrollbar-always-visible tabIndex={0} dir={isRtl ? 'rtl' : 'ltr'}>
        {DEVICE_TYPES.DESKTOP(windowWidth) && (
          <Flex justifyContent="center" alignItems="center" py="10px" mx="-10px" mb="10px" borderRadius="15px">
            <Link to={keys.ROUTE_NAMES.NEWS_FEED} state={{ fromUserClick: true }}>
              <Logo src={logoSrc} w="196px" maxHeight="40px" />
            </Link>
          </Flex>
        )}
        <NavMenu />
      </ScrollableMenu>

      <Box flexShrink={0} px="16px">
        <Divider m="0" />
        <SidebarUserCard />
      </Box>
    </StyledSidebar>
  )
}

export default Sidebar
